import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, permission }) => {
    const { token, user } = useAuth();
    const location = useLocation();

    if (!token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (permission && user) {
        // Check if user has required permission
        const userPermissions = user.permissions || [];
        // Support 'route:/admin' or 'admin.access' etc.
        // Also allow if user has '*' (superuser concept, optional)
        if (!userPermissions.includes(permission)) {
            return <div style={{ padding: '20px', textAlign: 'center' }}>
                <h2>Access Denied</h2>
                <p>You do not have permission to view this page ({permission}).</p>
            </div>;
        }
    }

    return children;
};

export default ProtectedRoute;
